import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

interface NavbarProps {
  username: string | undefined;
  onLogout: () => void;
}

const navItems = [
  { to: '/', label: 'Home' },
  { to: '/holdings', label: 'Holdings' },
  { to: '/transactions', label: 'Transactions' },
  { to: '/monitoring', label: 'Monitoring' },
  { to: '/form4', label: 'Form4' },
  { to: '/sedi', label: 'Sedi' },
  { to: '/institutions', label: 'Institutions' },
  { to: '/insiders', label: 'Insiders' },
  { to: '/configuration', label: 'Config' },
  { to: '/users', label: 'Users' },
];

const Navbar: React.FC<NavbarProps> = ({ username, onLogout }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    onLogout();
    navigate('/login');
  };

  return (
    <nav style={styles.nav}>
      <ul style={styles.ul}>
        {navItems.map((item) => {
          const isActive = location.pathname === item.to;
          return (
            <li key={item.label} style={styles.li}>
              <Link
                to={item.to}
                style={{
                  ...styles.link,
                  ...(isActive ? styles.activeLink : {}),
                }}
              >
                {item.label}
              </Link>
            </li>
          );
        })}
        <li style={styles.logoutLi}>
          <span onClick={handleLogout} style={styles.logoutLink}>
            Logout
          </span>
        </li>
      </ul>
    </nav>
  );
};

const styles: { [key: string]: React.CSSProperties } = {
  nav: {
    backgroundColor: '#cce6ff',
    borderBottom: '1px solid #727272',
    color: '#1a1a1a',
    fontSize: '0.8em',
    fontWeight: 'bold',
    height: '2.8em',
    lineHeight: '2.8em',
  },
  ul: {
    listStyle: 'none',
    margin: 0,
    padding: 0,
    display: 'flex',
    height: '2.8em',
  },
  li: {
    display: 'inline',
    borderRight: '1px solid #fff',
    padding: 0,
  },
  link: {
    color: '#1a1a1a',
    textDecoration: 'none',
    padding: '0 0.8em',
    textTransform: 'uppercase',
    display: 'inline-block',
    lineHeight: '2.8em',
    whiteSpace: 'nowrap',
  },
  activeLink: {
    backgroundColor: '#339cff',
    color: '#fff',
  },
  logoutLi: {
    marginLeft: 'auto',
    display: 'inline',
  },
  logoutLink: {
    color: '#1a1a1a',
    textDecoration: 'none',
    cursor: 'pointer',
    padding: '0.8em 1.2em',
    display: 'inline-block',
    fontSize: '1em',
  },
};

export default Navbar;
